import React from 'react';
import styled from '@emotion/styled';
import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const Container = styled.div({
  marginBottom: pxToRem(48),
  marginTop: pxToRem(-16),
  width: `calc(${pxToRem(186)} * 1.65)`,
  height: pxToRem(186),

  [mqBreakpoints.tablet]: {
    marginBottom: pxToRem(64),
    marginTop: pxToRem(32),
    width: `calc(${pxToRem(400)} * 1.65)`,
    height: pxToRem(400),
  },

  [mqBreakpoints.desktop]: {
    marginBottom: pxToRem(88),
    marginTop: pxToRem(48),
    width: `calc(${pxToRem(566)} * 1.65)`,
    height: pxToRem(566),
  },
});

export const BenefitsTpLaptopContainer: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};
